"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.featureToggle = exports.FeatureToggle = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const Subject_1 = require("rxjs/internal/Subject");
const merge_1 = __importDefault(require("lodash/merge"));
const constants_1 = require("../constants");
class FeatureToggle {
    constructor() {
        this.features = {};
        this.subject = new Subject_1.Subject();
    }
    subscribe(callback) {
        return this.subject.subscribe(callback);
    }
    addFeatures(features) {
        this.features = (0, merge_1.default)(this.features, features);
        this.subject.next();
    }
    parseCookie(cookieName = constants_1.COOKIE_NAME) {
        const featuresFromCookieAsString = js_cookie_1.default.get(cookieName);
        if (featuresFromCookieAsString) {
            const featuresFromCookieAsArray = JSON.parse(featuresFromCookieAsString);
            featuresFromCookieAsArray.forEach((feature) => {
                this.addFeature(feature, true);
            });
        }
    }
    addFeature(name, value) {
        this.features = this.updateByName(name, value);
        this.subject.next();
    }
    getFeatures() {
        return this.features;
    }
    getFeatureValue(name, features = this.features) {
        // eslint-disable-next-line no-restricted-syntax
        for (const featureName of Object.keys(features)) {
            const value = features[featureName];
            if (featureName === name) {
                return value;
            }
            if (typeof value === 'object') {
                const result = this.getFeatureValue(name, value);
                if (result !== null) {
                    return result;
                }
            }
        }
        return null;
    }
    isEnabled(name) {
        const value = this.getFeatureValue(name);
        return typeof value === 'boolean' ? value : true;
    }
    updateByName(name, value, features = this.features) {
        const featuresNew = Object.assign({}, features);
        // eslint-disable-next-line no-restricted-syntax
        for (const featureName of Object.keys(features)) {
            const featureValue = features[featureName];
            if (name === featureName) {
                if (typeof value === 'object' && typeof featureValue === 'object') {
                    featuresNew[featureName] = Object.assign(Object.assign({}, featureValue), value);
                }
                else {
                    featuresNew[featureName] = value;
                }
            }
            else if (typeof featureValue === 'object') {
                featuresNew[featureName] = this.updateByName(name, value, featureValue);
            }
        }
        return featuresNew;
    }
}
exports.FeatureToggle = FeatureToggle;
const featureToggle = new FeatureToggle();
exports.featureToggle = featureToggle;
